import 'lib-flexible/flexible.js';
import "@/assets/css/index.scss";
import { createApp } from "vue";
import router from "./router/index.js";
import store from "./store.js";
import {
  Icon as TIcon,
  Popup as TPopup,
  DateTimePicker as TDateTimePicker,
  Checkbox as TCheckbox,
  CheckboxGroup as TCheckboxGroup,
} from 'tdesign-mobile-vue';
// 引入组件库的少量全局样式变量
import 'tdesign-mobile-vue/es/style/index.css';
import App from "./App.vue";
import {
  Toast,
  Icon,
  InfiniteLoading,
  OverLay,
  Progress,
  Tabs,
  TabPane,
  ImagePreview,
  Swiper,
  SwiperItem,
  Popup,
  Dialog,
  Button,
  Navbar,
  Cell,
  CellGroup,
  Uploader,
  TextArea,
  DatePicker,
  Picker,
  Video,
  ActionSheet,
  Checkbox,
  CheckboxGroup,
  Form,
  FormItem,
  Input,
  NoticeBar,
} from "@nutui/nutui";
import "@nutui/nutui/dist/style.css";
import BeaconAction from '@tencent/beacon-web-sdk';
import 'resize-observer-polyfill';
import Aegis from 'aegis-web-sdk';
// import Vconsole from 'vconsole'
// let vConsole = new Vconsole()
let success = () => {
  // console.log('onReportSuccess : ' + e);
};
let fail = () => {
  // console.log('onReportFail : ' + e);
};
let beacon = new BeaconAction({
  appkey: '0WEB00S3XJ43IJ2W', // 系统或项目id, 必填
  versionCode: '2.11.1', //项目版本,选填
  channelID: 'channel', //渠道,选填
  openid: 'openid', // 用户id, 选填
  isDebug: false, // 是否开启实时联调, 默认关闭,选填
  strictMode: false,//严苛模式开关, 打开严苛模式会主动抛出异常, 上线请务必关闭!!!
  delay: 3000, // 普通事件延迟上报时间(单位毫秒), 默认3000(3秒),选填
  sessionDuration: 60 * 1000,// session变更的时间间隔, 一个用户持续30分钟(默认值)没有任何上报则算另一次 session,每变更一次session上报一次启动事件(rqd_applaunched),使用毫秒(ms),最小值30秒,选填
  onReportSuccess: success, // 上报成功回调,选填
  onReportFail: fail, // 上报失败回调,选填
});
beacon.onDirectUserAction('eventCode', {
  'city': 'shenzhen'
});

// 添加报错信息收集，可在TAM平台查看
window.aegis = new Aegis({
  id: 'aIRinzYdrqAkyPdLmN', // 项目ID，即上报id
  uin: '', // 用户唯一 ID（可选）
  reportApiSpeed: true, // 接口测速
  reportAssetSpeed: true, // 静态资源测速
  spa: true, // spa 页面开启
  // hostUrl: 'https://rumt-zh.com',
  api: {
    apiDetail: true, // 接口详情
  },
})
// window.console.log(window.location);

// 判断url是否包含
if(window.location.search){
  const searchValue = window.location.search.split('?')[1].split('&')
  searchValue.map(item => {
    let res = item.split('=')
    if(res[0] == 'source'){
      beacon.onUserAction('user_level_show', {
        source: res[1]
      })
    }
  })
}

// window.console.log(beacon.getDeviceId());
function throttle(cd, time = 200) {
  var t = null;
  return function(){
    if(t) return;
    t = setTimeout(() => {
      cd.call(this);
      t = null;
    }, time);
  };
}

const app = createApp(App);

app.directive('clickEvent', {
  beforeMount(el, binding) {
    el.onclick = throttle(binding.value)
  },
});

app.config.globalProperties.beacon = beacon;

app.config.errorHandler = function(err, vm, info) {
  console.log(`Error: ${err.toString()}\nStack: ${err.stack}\nInfo: ${info}`);
  window.aegis && window.aegis.error(`Error: ${err.toString()}\nStack: ${err.stack}\nInfo: ${info}`);
};

app
  .use(router)
  .use(store)
  .use(Toast)
  .use(Icon)
  .use(InfiniteLoading)
  .use(OverLay)
  .use(Progress)
  .use(Tabs)
  .use(TabPane)
  .use(ImagePreview)
  .use(Swiper)
  .use(SwiperItem)
  .use(Popup)
  .use(Dialog)
  .use(Button)
  .use(Navbar)
  .use(Cell)
  .use(CellGroup)
  .use(Uploader)
  .use(TextArea)
  .use(DatePicker)
  .use(Picker)
  .use(Video)
  .use(ActionSheet)
  .use(Checkbox)
  .use(CheckboxGroup)
  .use(Form)
  .use(FormItem)
  .use(Input)
  .use(NoticeBar)
  .use(TIcon)
  .use(TPopup)
  .use(TDateTimePicker)
  .use(TCheckbox)
  .use(TCheckboxGroup)
  // .use(vConsole)
  .mount("#app");

